import type { Client } from '@core/types';

/** CLI-051: When false, new requisitions and jobs must not be created for this client. */
export function isClientReadyForRecruitment(client: Client | null | undefined): boolean {
  if (!client) return false;
  return client.client_onboarding_status === 'ready_to_recruit';
}
